/**
 * @desc 查询售后门店详情
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** 售后门店id */
  id?: string;
  /** 纬度 */
  lat?: string;
  /** 经度 */
  lon?: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.WrapResponse<defs.store.AfterSaleStoreDetail>>(
    `/storeapi/after/sale/store/detail`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.WrapResponse<defs.store.AfterSaleStoreDetail>;
export default req;
